enum CustomerRewardType {
    RewardGroup = 'RewardGroup',
    Reward = 'Reward',
    Claim = 'Claim',
}

export default CustomerRewardType;
